import { render } from "./AddSalary.vue?vue&type=template&id=60f6c95d"
import script from "./AddSalary.vue?vue&type=script&lang=js"
export * from "./AddSalary.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__